import type {
  GovernanceIssuePriority,
  GovernanceIssueStatus,
  GovernanceIssuesDateRange,
} from '@http/queries/useFetchGovernanceIssues';

export const STATUS_OPTIONS: GovernanceIssueStatus[] = [
  'open',
  'fixed',
  'ignored',
];

export const PRIORITY_OPTIONS: GovernanceIssuePriority[] = [
  'high',
  'medium',
  'low',
];

export const DATE_OPTIONS: GovernanceIssuesDateRange[] = [
  '90d',
  '30d',
  '7d',
  '24h',
];

export const GROUP_BY_OPTIONS = [
  { key: 'none', labelKey: 'groupByNone' },
  { key: 'policy', labelKey: 'groupByPolicy' },
  { key: 'page', labelKey: 'groupByPage' },
  { key: 'domain', labelKey: 'groupByDomain' },
  { key: 'priority', labelKey: 'groupByPriority' },
] as const;

export type GroupByKey = (typeof GROUP_BY_OPTIONS)[number]['key'];

export const STATUS_LABELS: Record<GovernanceIssueStatus, string> = {
  open: 'statusOpen',
  fixed: 'statusFixed',
  ignored: 'statusIgnored',
  stale: 'statusStale',
};

export const STATUS_TAG_VARIANTS: Record<
  GovernanceIssueStatus,
  'warning' | 'success' | 'hint' | 'outline'
> = {
  open: 'warning',
  fixed: 'success',
  ignored: 'hint',
  stale: 'outline',
};
